module.exports = __webpack_public_path__ + "static/valkoinenlogo-ea3e98e3c42dc811bc8c8f8c5f86ad03.png";